import React from "react";

export default function SQLServer_UNICODE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_UNICODE</h1>
      <p>This is the SQLServer_UNICODE component generated from the SQL JSON.</p>
    </div>
  );
}
